// extracted by mini-css-extract-plugin
export default {"events":"EventsList_events__rcyhB","list":"EventsList_list__f-rtN","item":"EventsList_item__2nPPz","content":"EventsList_content__4vSqf"};